/* eslint-disable no-unsafe-optional-chaining */
import { useContext, useEffect, useState } from 'react'
import { DefaultButton, PinConfirmation } from 'components/index'
import { UserContext } from 'context/userContext'
import { clearString, extract, numberToMoney } from 'helper/utils'
import useFetch from 'hooks/useFetch'
import { Container } from './style'

const ResumoTransferir = (props: any) => {
  const { resumo, data, setPage } = useContext(UserContext)
  const [showPinConfirmation, setShowPinConfirmation] = useState(false)
  const [pinText, setPinText] = useState({})
  const api = useFetch()

  const content = {
    0: {
      title: 'Código de verificação',
      titleTxt: [
        `Digite o código de 4 dígitos que te enviamos por`,
        `SMS no número 000000-0000`,
      ],
      icon: 'check_circle.svg',
    },
    1: {
      title: 'Conta Bloqueada',
      titleTxt: [
        'A solicitação de edição de valor foi reprovada.',
        'Sua conta foi bloqueado devido a atividades suspeitas.',
        'Contate o suporte para recuperação.',
      ],
      icon: 'x_circle.svg',
    },
    2: {
      title: 'Transferência realizada',
      titleTxt: [],
      icon: 'check_circle.svg',
    },
    3: {
      title: 'Erro de solicitção',
      titleTxt: [
        `Houve uma falha ao enviar dados ao servidor `,
        `Tente novamente mais tarde`,
      ],
      icon: 'x_circle.svg',
    },
  }

  useEffect(() => {
    setPinText(content)
  }, [])

  // ***********************************************
  // REQUISICAO PARA FAZER A TRANSFERENCIA DE SAIDA DA CONTA DE EMPREENDIMENTO
  // esse endpoint faz uma busca das informacoes ligadas a chave pix selecionada
  // para preencher a pagina de resumo
  // ***********************************************
  const requestTransfer = async () => {
    try {
      const response: any = await api.fetch(
        'get',
        null,
        `/gestor/withdraw/${
          data?.account?.value === 'main_account' ? 'client' : 'enterprise'
        }?id=${data?.account?.value}&value=${
          resumo?.transferValue
        }&to=${clearString(resumo?.pixKey)}&pixType=${resumo?.pixType}`
      )
      console.log(response)
      if (!response || response.fail) {
        response.errors.message &&
          setPinText((last) => ({
            ...last,
            3: {
              title: 'Erro de solicitação',
              titleTxt: [response?.errors?.message],
              icon: 'x_circle.svg',
            },
          }))
        return 3
      }

      return 2
      // ***********************************************
    } catch (err: any) {
      console.error('err', err)
      return err
    }
  }

  return (
    <Container style={{ width: '100%' }}>
      <div className="transferir-details-container">
        <span className="transferir-text1">Transferindo</span>
        <span className="transferir-value">{`R$ ${numberToMoney(
          resumo?.transferValue
        )}`}</span>
        <span className="transferir-text2">
          Confira os dados de transferência
        </span>
        <div>
          <span className="transferir-text1">Quem vai receber</span>
          <div className="transferir-info-banco">
            <div className="transferir-info-banco-col1">
              <div className="transferir-info-banco-pixInfo">
                <span className="transferir-info-banco-pixInfo-text1">
                  Chave Pix
                </span>
                <span className="transferir-info-banco-pixInfo-text2">
                  {resumo?.pixKey}
                </span>
              </div>
            </div>
            <div className="transferir-info-banco-col1">
              <span className="transferir-info-banco-pixInfo-text1">Nome</span>
              <span className="transferir-info-banco-pixInfo-text2">
                {resumo?.to?.name}
              </span>
            </div>
            <div className="transferir-info-banco-col1">
              <span className="transferir-info-banco-pixInfo-text1">CPF</span>
              <span className="transferir-info-banco-pixInfo-text2">
                {resumo?.to?.document}
              </span>
            </div>
            <div className="transferir-info-banco-col1">
              <span className="transferir-info-banco-pixInfo-text1">
                Instituição
              </span>
              <span className="transferir-info-banco-pixInfo-text2">
                {resumo?.to?.institution}
              </span>
            </div>
          </div>
          <span className="transferir-text1">Data</span>
          <div className="transferir-info-banco2">
            <span className="transferir-info-banco-pixInfo-text1">
              Quando você vai transferir?
            </span>
            <span className="transferir-info-banco-pixInfo-text2">
              {extract(new Date(resumo?.date))}
              {` ${new Date(resumo?.date).getFullYear()}`}
            </span>
          </div>
          <span className="transferir-text1">Detalhes da transação</span>
          <div className="transferir-info-banco">
            <div className="transferir-info-banco-col1">
              <span className="transferir-info-banco-pixInfo-text1">Tipo</span>
              <span className="transferir-info-banco-pixInfo-text2">Pix</span>
            </div>
            <div className="transferir-info-banco-col1">
              <span className="transferir-info-banco-pixInfo-text1">
                Tarifa
              </span>
              <span className="transferir-info-banco-pixInfo-text2">
                {`R$ ${numberToMoney(
                  Number(resumo?.transferValue) * resumo?.tax
                )}`}
              </span>
            </div>
          </div>
          <DefaultButton
            onClick={async () => {
              await api.fetch('get', null, `/gestor/send-sms-code`)
              setShowPinConfirmation(true)
            }}
            big
            height={50}
          >
            Confirmar transferência
          </DefaultButton>
        </div>
      </div>
      {showPinConfirmation && (
        <PinConfirmation
          setShowPinConfirmation={setShowPinConfirmation}
          content={pinText}
          setContent={setPinText}
          handleSend={requestTransfer}
          setEnd={() => setPage(0)}
          confirmButton="Confirmar"
        />
      )}
    </Container>
  )
}

export default ResumoTransferir
